module.exports = __webpack_public_path__ + "img/bx-grade-timetable-active.f3642353.svg";